export default "__VITE_ASSET__CEh4$LEp__"